var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGapassessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72.000000pt",
    height: "59.000000pt",
    viewBox: "0 0 72.000000 59.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,59.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170 501 c-6 -11 -10 -87 -10 -175 l0 -156 140 0 c87 0 140 4 140 10 0 6 -44 10 -111 10 l-111 0 6 24 c3 13 19 53 35 90 l30 66 166 0 166 0 -7 -22 c-4 -13 -9 -28 -11 -34 -2 -7 0 -15 5 -18 13 -8 46 74 34 86 -5 5 -91 7 -191 6 l-183 -3 -29 -70 c-16 -38 -33 -79 -38 -90 -7 -13 -10 27 -10 123 l-1 142 66 0 c49 0 73 -5 93 -20 23 -15 48 -20 127 -22 94 -3 99 -4 102 -25 4 -30 22 -30 22 0 0 39 -18 47 -114 47 -79 1 -96 4 -131 25 -32 20 -53 25 -107 25 -56 0 -69 -3 -78 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493 272 c-32 -25 -44 -64 -32 -104 11 -41 12 -38 -4 -38 -7 0 -28 -15 -46 -34 -35 -36 -37 -66 -3 -66 19 0 65 44 75 72 5 14 10 15 35 6 38 -15 78 -3 109 30 52 57 5 152 -75 152 -20 0 -47 -8 -59 -18z m77 -12 c0 -6 -7 -24 -15 -40 -12 -23 -22 -30 -45 -30 -37 0 -40 23 -8 57 22 23 68 32 68 13z m51 -37 c13 -35 -4 -76 -37 -92 -36 -16 -50 -14 -81 14 l-28 24 43 1 c40 0 43 2 58 40 19 47 31 50 45 13z m-181 -148 c-13 -14 -28 -25 -34 -25 -5 0 3 13 19 30 16 16 31 28 33 25 3 -3 -5 -16 -18 -30z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGapassessment);
export default __webpack_public_path__ + "static/media/gapassessment.1ea275eccc288561735632d6120bb397.svg";
export { ForwardRef as ReactComponent };